import {
  format as formatDate,
  parseISO
} from 'date-fns'
import { formatNumber } from 'humanize-plus'
import {
  find,
  pathOr,
  propEq
} from 'ramda'
import React from 'react'

import { Avatar } from '@driftt/tide-core'

const contactPropertyTypeResolvers = {
  'STRING': value => value,
  'NUMBER': value => formatNumber(value),
  'DATETIME': value => {
    try {
      const parsedTimeValue = typeof value == 'string'
        ? parseISO(value)
        : value

      return formatDate(parsedTimeValue, 'MM/dd/yyyy')
    } catch (err) {
      return value
    }
  }
}

const contactPropertyResolvers = {
  'avatarUrl': contact => (
    <Avatar
      user={contact}
      type="user"
      size="mini"
    />
  ),
  'name': contact => contact.name || contact.alias || contact.email,
  'createdAt': contact => contactPropertyTypeResolvers['DATETIME'](contact.createdAt),
  'last_active': contact => contactPropertyTypeResolvers['DATETIME'](contact.attributes.last_active),
  'start_date': contact => contactPropertyTypeResolvers['DATETIME'](contact.attributes.start_date),
  'last_contacted': contact => contactPropertyTypeResolvers['DATETIME'](contact.attributes.last_contacted),
  'latest_dup': contact => contactPropertyTypeResolvers['DATETIME'](contact.latest_dup),
  'dup_count': contact => contactPropertyTypeResolvers['NUMBER'](contact.dup_count),
}


export const resolvePropertyLabel = contactProperties => {
  return (property) => {
    const propertyDefinition = find(propEq('name', property))(contactProperties)

    return propertyDefinition?.displayName ?? property
  }
}

export const resolvePropertyValue = contactProperties => {
  const resolveByType = (property, contact, value) => {
    const propertyDefinition = find(propEq('name', property))(contactProperties)
    const propertyType = pathOr('STRING', ['type'])(propertyDefinition)
    const propertyValue = value || contact[property] || contact.attributes[property] || ''
    const propertyTypeResolver = contactPropertyTypeResolvers[propertyType] || ((value) => value)

    return propertyTypeResolver(propertyValue)
  }

  return (property, contact, value) => {

    const customResolver = contactPropertyResolvers[property]
    return customResolver
      ? customResolver(contact) || '--'
      : resolveByType(property, contact, value)
  }
}

export default contactPropertyResolvers
